export const ROOT_DROPZONE_ID = "__kb_root_dropzone__";

